import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import recipeConfirmation from "../../../../src/content/graham-recipe-cards-2edition-digital/recipeConfirmation";
import * as React from 'react';
export default {
  NewNamesForm,
  recipeConfirmation,
  React
};